﻿import * as paths from '../utils/paths';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import { get as getProjection, addProjection, transform } from 'ol/proj';
import WKT from 'ol/format/WKT';
import GeoJSON from 'ol/format/GeoJSON';

export default class ProjectionHandler {
    constructor(rootURL) {
        this.rootURL = rootURL;
        this.projections = {};
        this.format = new WKT();
        this.geojsonFormat = new GeoJSON();
    }

    load(projectionId) {
        return new Promise((resolve, reject) => {
            if (!this.projections[projectionId]) {
                $.ajax({
                    type: "GET",
                    url: this.rootURL + paths.SYST_COORD_URL + projectionId,
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    success: (result) => {
                        if (result != null && result.Id != null) {
                            this._setProj(result);
                        }
                        resolve();
                    },
                    error: (e) => {
                        reject(e);
                    }
                });
            } else {
                resolve();
            }
        });
    }

    getProj(projectionId) {
        return getProjection(projectionId);
    }

    getProjExtent(projectionId) {
        return getProjection(projectionId).getExtent();
    }

    _setProj(projConfig) {
        this.projections[projConfig.Id] = projConfig;
        proj4.defs(projConfig.Id, projConfig.Def);
        register(proj4);
        var projection = getProjection(projConfig.Id);
        projection.setExtent(projConfig.Extent);
        addProjection(projection);
    }

    geometryToWkt(geometry, featureProjection, dataProjection) {
        return this.format.writeGeometry(geometry, { featureProjection: featureProjection, dataProjection: dataProjection });
    }

    wktToGeometry(wkt, featureProjection, dataProjection) {
        return this.format.readFeature(wkt, { featureProjection: featureProjection, dataProjection: dataProjection });
    }

    transformCoordinates(coordinates, fromProjection, toProjection) {
        return transform(coordinates, fromProjection, toProjection);
    }

    geojsonToFeatures(geojson, dataProjection, featureProjection) {
        return this.geojsonFormat.readFeatures(geojson, { dataProjection: dataProjection, featureProjection: featureProjection });
    }
}